// extracted by mini-css-extract-plugin
export default {"loader":"AdyenPayment_loader__JKHpR","hide":"AdyenPayment_hide__UkdNJ"};